import React from 'react';

// Styles
import {
	ContentWrapperStyled,
	CenterContainerStyled,
} from './LoadingContainer.styled';

const LoadingContainer = () => {
	return (
		<ContentWrapperStyled>
			<CenterContainerStyled>Loading Content</CenterContainerStyled>
		</ContentWrapperStyled>
	);
};

export default LoadingContainer;
